import React, { useEffect, useState } from "react";
import "./index.scss";
import { Page } from "../../../../enums/page";
import { get as getCookie } from "../../../../utils/cookies";
import { useSelector } from "react-redux";
import { RootState } from "../../../../store";

export const GetSizeQtyBoxes = (sortedLineItems, currentPage, lineItemId, apparelSortedSizes:string[] = []) => {
    const sizeQtyBoxes: JSX.Element[] = [];
    const [removedSizes, setRemovedSizes] = useState('');
    const {
        applicationState: { checkOOSStatus }
      }: any = useSelector((state: RootState) => state);

    useEffect(()=>{
        const isLineItemsRemovedArray = getCookie('np.isLineItemsRemoved');
        if(isLineItemsRemovedArray){
            const parsedArray = JSON.parse(isLineItemsRemovedArray);
            setRemovedSizes(getRemovedSizes(lineItemId, parsedArray));
        } else {
            setRemovedSizes('');
        }
    },[lineItemId, checkOOSStatus]);

    function getRemovedSizes(lineItemId, parsedArray) {
        const item = parsedArray.find(obj => obj.lineItemId === lineItemId);
        return item ? item.SIZE : '';
    }
    
    const sizes = [
        // Extract sizes from sortedLineItems if it exists
        ...(sortedLineItems && Array.isArray(sortedLineItems)
            ? sortedLineItems
                  .filter(({ data }) => data?.multiSelectData?.isExist)
                  .map(({ data }) => ({
                      size: data.multiSelectData.value.toUpperCase(),
                      quantity: data.quantity,
                  }))
            : []),
        // Add removed sizes with quantity 0 if removedSizes exists
        ...(removedSizes.length > 0
            ? removedSizes.split('|').map((item) => ({
                  size: item.toUpperCase(),
                  quantity: 0,
              }))
            : []),
    ];
    

    // Sort sizes if apparelSortedSizes is defined
    if (apparelSortedSizes.length > 0) {
        sizes.sort((a, b) => 
            apparelSortedSizes.indexOf(a.size) - apparelSortedSizes.indexOf(b.size)
        );
    }

    // Generate JSX elements
    sizes.forEach(({ size, quantity }, index) => {
        const outOfStock = quantity === 0;
        const isCheckoutPage = currentPage === Page.CHECKOUTSHIPPING || currentPage === Page.CHECKOUTPAYMENT || currentPage === Page.ORDERCONFIRMATION;

        sizeQtyBoxes.push(
            <span className={`sizeQtyBox ${outOfStock ? 'fadeEffect' : ''} ${isCheckoutPage ? 'checkout-qty-box' : ''}`} key={index}>
                <span className={outOfStock ? 'strike' : ''}>{size}</span>{' '}
                <span className="qtyNumber">{quantity}</span>
            </span>
        );
    });

    return sizeQtyBoxes;
}